import React, { useEffect, useState } from "react";
import Wallet from "../../../shared-components/Wallet/Wallet";
import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import { useAccount } from "wagmi";
import { nftContract, web3, contractAddress, weiToEth, secondsToDays, convertUnixTimestampToDate } from "../../../utilis/web3";
import { Link } from "react-router-dom";
//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function ConnectWallet() {
  AnimationFileLoader();
  const { address, isDisconnected } = useAccount();
  const [nFTs, setNFTs] = useState([]);

  const changeNFTs = (tokenIdToRemove) => {
    setNFTs((prevNFTs) => {
      const updatedNFTs = { ...prevNFTs };
      delete updatedNFTs[tokenIdToRemove];
      return updatedNFTs;
    });
  };

  useEffect(() => {
    if (address && nftContract) {
      // Fetch NFTs owned by the connected wallet
      const fetchMyNFTs = async () => {
        try {
          const tokens = await nftContract.methods
            .getTokensByOwner(address)
            .call();
          const allListings = await nftContract.methods.getAllListings().call();
          const allAuctions = await nftContract.methods.getCurrentAuctions().call();

          const nftData = await Promise.all(
            tokens.map(async (tokenId) => {
              const tokenURI = await nftContract.methods
                .getTokenURI(tokenId)
                .call();
              const response = await fetch(tokenURI);
              const metadata = await response.json();

              return { [tokenId]: { ...metadata, listed: false } };
            })
          );

          const listingData = await Promise.all(
            allListings.map(async (listing) => {
              if (listing.seller === address) {
                const tokenURI = await nftContract.methods
                  .getTokenURI(listing.tokenId)
                  .call();
                const response = await fetch(tokenURI);
                const metadata = await response.json();

                return { [listing.tokenId]: { ...metadata, listed: true } };
              }
            })
          );

          const auctionData = await Promise.all(
            allAuctions.map(async (auction) => {
              if (auction.active) {

                if (auction.seller === address) {

                  const tokenURI = await nftContract.methods
                    .getTokenURI(auction.tokenId)
                    .call();
                  const response = await fetch(tokenURI);
                  const metadata = await response.json();

                  return {
                    [auction.tokenId]: {
                      ...metadata,
                      auctioned: true,
                      seller: auction.seller,
                      startingAuctionPrice: weiToEth(auction.startingPrice),
                      currentAuctionBid: weiToEth(auction.highestBid),
                      highestAuctionBidder: auction.highestBidder,
                      duration: secondsToDays(parseInt(auction.duration)),
                      endTime: convertUnixTimestampToDate(parseInt(auction.endTime))

                    }
                  };

                } else if (auction.highestBidder === address) {

                  const tokenURI = await nftContract.methods
                    .getTokenURI(auction.tokenId)
                    .call();
                  const response = await fetch(tokenURI);
                  const metadata = await response.json();

                  return {
                    [auction.tokenId]: {
                      ...metadata,
                      bid: true,
                      seller: auction.seller,
                      startingAuctionPrice: weiToEth(auction.startingPrice),
                      currentAuctionBid: weiToEth(auction.highestBid),
                      highestAuctionBidder: auction.highestBidder,
                      duration: secondsToDays(parseInt(auction.duration)),
                      endTime: convertUnixTimestampToDate(parseInt(auction.endTime))

                    }
                  };
                }

              }
            })
          );

          // Now, you have an array of objects, let's convert it to a single object
          const nftDataObject = [...nftData, ...listingData, ...auctionData].reduce(
            (result, item) => {
              return { ...result, ...item };
            },
            {}
          );
          console.log(nftDataObject)
          setNFTs(nftDataObject);
        } catch (error) {
          console.error("Error fetching NFTs:", error);
        }
      };

      fetchMyNFTs();
    }
  }, [address]);

  return (
    <>
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Create Collectible */}
      <section className="pt-120 pb-90">
        <div className="container">
          {isDisconnected ? (
            // Display when the wallet is disconnected
            <div className="d-flex flex-column text-center justify-content-center align-items-center">
              <div className="row justify-content-center">
                <div className="">
                  <div className="section-title text-center text-white">
                    <h2>Connect Wallet</h2>
                    <p>Connect your wallet to show your NFTs.</p>
                  </div>
                </div>
              </div>
              {/* <w3m-button /> */}
            </div>
          ) : Object.keys(nFTs).length > 0 ? (
            // Display when the wallet is connected and there are NFTs
            <>
              <div className="row">
                {Object.keys(nFTs).map((tokenId, index) => {
                  const nft = nFTs[tokenId];
                  return (
                    <div key={index} className="col-xl-3 col-lg-4 col-sm-6">
                      {/* Wallet */}
                      <Wallet
                        logoClass="logo"
                        classList="wallet style--two text-white"
                        web3={web3}
                        contractAddress={contractAddress}
                        contract={nftContract}
                        address={address}
                        tokenId={tokenId}
                        imgSrc={nft?.image}
                        supply={nft?.supply}
                        blockchain={nft?.blockchain}
                        name={nft?.name}
                        collection={nft?.collection}
                        description={nft?.description}
                        listed={nft?.listed}
                        auctioned={nft?.auctioned}
                        bid={nft?.bid}
                        seller={nft?.seller}
                        startingAuctionPrice={nft?.startingAuctionPrice}
                        currentAuctionBid={nft?.currentAuctionBid}
                        highestAuctionBidder={nft?.highestAuctionBidder}
                        duration={nft?.duration}
                        endTime={nft?.endTime}
                        changeNFTs={changeNFTs}
                      />
                      {/* End Wallet */}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="d-flex flex-column text-center justify-content-center align-items-center">
              <div className="row justify-content-center">
                <div className="">
                  <div className="section-title text-center text-white">
                    <h2 className="text-nowrap">No Assets</h2>
                    <p>Mint your own NFTs and list them.</p>
                  </div>
                </div>
              </div>
              <Link
                type="button"
                to="/explore/create/upload"
                className="btn btn-primary mx-auto"
              >
                Mint NFT
              </Link>
            </div>
          )}
        </div>
      </section>
      {/* End Create Collectible */}
    </>
  );
}

export default ConnectWallet;
